/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Permissions_SavedInputs */

const en_admin_roles_permissions_saved = /** @type {(inputs: Admin_Roles_Permissions_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions updated`)
};

const zh_admin_roles_permissions_saved = /** @type {(inputs: Admin_Roles_Permissions_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限已更新`)
};

/**
* | output |
* | --- |
* | "Permissions updated" |
*
* @param {Admin_Roles_Permissions_SavedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_permissions_saved = /** @type {((inputs?: Admin_Roles_Permissions_SavedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Permissions_SavedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_permissions_saved(inputs)
	return zh_admin_roles_permissions_saved(inputs)
});
export { admin_roles_permissions_saved as "admin.roles.permissions_saved" }